import Axios from "axios";
import config from "config";

export const startLogin = async (username, password) => {
  try {
    const url = `${config.apiserver}/auth/startlogin/`;

    const user = await Axios.post(url, {
      username,
      password,
    });
    return user.data;
  } catch (err) {
    const data = {
      success: false,
    };
    return data;
  }
};
export const login = async (username, password) => {
  try {
    const url = `${config.apiserver}/auth/login/`;

    const user = await Axios.post(url, {
      username,
      password,
    });
    return user.data;
  } catch (err) {
    const data = {
      success: false,
    };
    return data;
  }
};
export const register = async (newUser, token) => {
  try {
    const url = `${config.apiserver}/auth/register/`;
    
    const user = await Axios.post(url, newUser, {
      headers: {
        "x-access-token": token,
      },
    });
    return user.data;
  } catch (err) {
    const data = {
      success: false,
    };
    return data;
  }
};
// export const getUser = async (id, token) => {
//   try {
//     const url = `${config.apiserver}/getuser/${id}`;
//     
//     const user = await Axios.get(url, {
//       headers: {
//         "x-access-token": token,
//       },
//     });
//     return user.data;
//   } catch (err) {
//     const data = {
//       success: false,
//     };
//     return data;
//   }
// };

export const verifyUser = async (newData, token) => {
  try {
    const url = `${config.apiserver}/auth/verifyUser/`;

    const res = await Axios.post(url, newData, {
      headers: {
        "x-access-token": token,
      },
    });

    return res.data;
  } catch (err) {
    const data = {
      success: false,
    };
    return data;
  }
};
export const updateUser = async (newData, token) => {
  try {
    const url = `${config.apiserver}/auth/updateuser/`;

    const res = await Axios.post(url, newData, {
      headers: {
        "x-access-token": token,
      },
    });

    return res.data;
  } catch (err) {
    const data = {
      success: false,
    };
    return data;
  }
};
export const activation = async (newData, token) => {
  try {
    const url = `${config.apiserver}/admin/updateuseractivation/`;

    const res = await Axios.put(url, newData, {
      headers: {
        "x-access-token": token,
      },
    });

    return res.data;
  } catch (err) {
    const data = {
      success: false,
    };
    return data;
  }
};

export const deleteUser = async (id, token) => {
  try {
    const url = `${config.apiserver}/auth/deleteuser/${id}`;
    const responce = await Axios.delete(url, {
      headers: {
        "x-access-token": token,
      },
    });

    return responce.data;
  } catch (err) {
    const data = {
      success: false,
    };
    return data;
  }
};

export const updatePermission = async (body, token) => {
  try {
    const url = `${config.apiserver}/updatepermission`;
    const user = await Axios.post(url, body, {
      headers: {
        "x-access-token": token,
      },
    });
    return user.data;
  } catch (err) {
    const data = {
      success: false,
    };
    return data;
  }
};

export const completProfile = async (profile, picture, token) => {
  try {
    const formData = new FormData();

    formData.append("picture", picture);
    formData.append("name", profile.name);
    formData.append("code", profile.code);
    formData.append("age", profile.age);
    formData.append("gender", profile.gender);
    formData.append("speciality", profile.speciality);
    formData.append("city", profile.city);
    formData.append("howToInform", profile.howToInform);
    formData.append("nationality", profile.nationality);
    formData.append("institution", profile.institution);
     const url = `${config.apiserver}/completprofile/`;
    const data = await Axios.post(url, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        "x-access-token": token,
      },
    });

    return data.data;
  } catch (err) {
    const data = {
      success: false,
      message: "Error in proccess",
    };
    return data;
  }
};
export const getSpecialities = async () => {
  try {
    const url = `${config.apiserver}/specialities`;
    const specialities = await Axios.get(url);
    return specialities.data;
  } catch (err) {
    const data = {
      success: false,
      message: "Error in proccess",
    };
    return data;
  }
};
export const getCountries = async () => {
  try {
    const url = `${config.apiserver}/countries`;
    const countries = await Axios.get(url);
    return countries.data;
  } catch (err) {
    const data = {
      success: false,
      message: "Error in proccess",
    };
    return data;
  }
};
export const getProfile = async (token) => {
  try {
    const url = `${config.apiserver}/getprofile`;
    const user = await Axios.get(url, {
      headers: {
        "x-access-token": token,
      },
    });

    return user.data;
  } catch (err) {
    const data = {
      success: false,
      message: "Error in proccess",
    };
    return data;
  }
};

export const changeUserRole = async (newDate, token) => {
  try {
    const url = `${config.apiserver}/admin/upateuserrole/`;
    const user = await Axios.put(url, newDate, {
      headers: {
        "x-access-token": token,
      },
    });
    return user.data;
  } catch (err) {
    const data = {
      success: false,
      message: "Error in proccess",
    };
    return data;
  }
};

export const changeUserActiveMode = async (lang, id, mode, token) => {
  try {
    const url = `${config.apiserver}/admin/changeuseractivemode/${lang}/${id}/${mode}`;
    const user = await Axios.put(url, null, {
      headers: {
        "x-access-token": token,
      },
    });
    return user.data;
  } catch (err) {
    const data = {
      success: false,
      message: "Error in proccess",
    };
    return data;
  }
};
export const getPassword = async (lang, id, token) => {
  try {
    const url = `${config.apiserver}/admin/getpassword/${lang}/${id}`;
    const user = await Axios.put(url, null, {
      headers: {
        "x-access-token": token,
      },
    });
    return user.data;
  } catch (err) {
    const data = {
      success: false,
      message: "Error in proccess",
    };
    return data;
  }
};

export const getCollaboratorsList = async (perpage, page, search, filter, token) => {
  try {
    const newData = {
      perpage,
      page,
      filter,
      search,
    };
    const url = `${config.apiserver}/auth/getCollaborators/`;

    const user = await Axios.post(url, newData, {
      headers: {
        "x-access-token": token,
      },
    });
    return user.data;
  } catch (err) {
    const data = {
      success: false,
      message: err,
    };
    return data;
  }
};
export const getCollaboratorsAndsupperCollaboratorsList = async (
  perpage,
  page,
  search,
  filter,
  token
) => {
  try {
    const newData = {
      perpage,
      page,
      filter,
      search,
    };
    const url = `${config.apiserver}/auth/getCollaboratorsAndsupperCollaborator/`;

    const user = await Axios.post(url, newData, {
      headers: {
        "x-access-token": token,
      },
    });
    return user.data;
  } catch (err) {
    const data = {
      success: false,
      message: err,
    };
    return data;
  }
};

export const getUsersList = async (perpage, page, search, filter, token) => {
  try {
    const newData = {
      perpage,
      page,
      filter,
      search,
    };
    const url = `${config.apiserver}/auth/users/`;

    const user = await Axios.post(url, newData, {
      headers: {
        "x-access-token": token,
      },
    });
    return user.data;
  } catch (err) {
    const data = {
      success: false,
      message: err,
    };
    return data;
  }
};
export const getUser = async (newData, token) => {
  try {
    const url = `${config.apiserver}/auth/getuser/`;
    const user = await Axios.post(url, newData, {
      headers: {
        "x-access-token": token,
      },
    });
    return user.data;
  } catch (err) {
    const data = {
      success: false,
      message: err,
    };
    return data;
  }
};
export const getUsersChart = async (token) => {
  try {
    const url = `${config.apiserver}/app/userschart/`;

    const user = await Axios.get(url, {
      headers: {
        "x-access-token": token,
      },
    });
    return user.data;
  } catch (err) {
    const data = {
      success: false,
      message: err,
    };
    return data;
  }
};
export const addUserToGroup = async (newUserGroup, token) => {
  try {
    const url = `${config.apiserver}/admin/addusertogroup/`;
    const result = await Axios.put(url, newUserGroup, {
      headers: {
        "x-access-token": token,
      },
    });
    return result.data;
  } catch (err) {
    const data = {
      success: false,
      message: err,
    };
    return data;
  }
};
